import { cn } from "@/lib/utils";

export function QuoteLeft({ className }: { className?: string }) {
  return (
    <svg
      width="38"
      height="30"
      viewBox="0 0 38 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(className)}
    >
      <path
        d="M29.1219 29.9978C25.1219 30.1038 20.7779 27.1278 20.0759 20.7978L20.0219 20.1718L20.0199 20.1598C19.6379 13.5218 24.2679 4.44576 34.3819 0.0817566C34.607 -0.015316 34.8598 -0.0263748 35.0925 0.0506821C35.3251 0.127739 35.5214 0.287544 35.6439 0.499756L37.8639 4.33776C37.9301 4.45233 37.9729 4.57891 37.9898 4.71014C38.0068 4.84138 37.9975 4.97467 37.9625 5.10228C37.9275 5.2299 37.8676 5.34931 37.7861 5.45358C37.7046 5.55786 37.6033 5.64493 37.4879 5.70975C34.0679 7.63375 31.4019 10.6518 29.7979 14.3138C32.1779 14.7338 33.8879 15.7198 35.0339 17.0338C36.3679 18.5658 36.8439 20.4338 36.8439 22.0678C36.8439 26.4958 33.4379 30.0778 29.1239 29.9978M9.12394 29.9978C5.12394 30.1038 0.779942 27.1278 0.0779419 20.7978L0.023941 20.1718L0.0219383 20.1598C-0.360062 13.5218 4.26994 4.44576 14.3839 0.0817566C14.609 -0.015316 14.8618 -0.0263748 15.0945 0.0506821C15.3271 0.127739 15.5234 0.287544 15.6459 0.499756L17.8659 4.33776C17.9321 4.45233 17.9749 4.57891 17.9918 4.71014C18.0088 4.84138 17.9995 4.97467 17.9645 5.10228C17.9295 5.2299 17.8696 5.34931 17.7881 5.45358C17.7066 5.55786 17.6053 5.64493 17.4899 5.70975C14.0699 7.63375 11.4039 10.6518 9.79994 14.3138C12.1799 14.7338 13.8899 15.7198 15.0359 17.0338C16.3699 18.5658 16.8459 20.4338 16.8459 22.0678C16.8459 26.4958 13.4359 30.0778 9.12394 29.9978Z"
        fill="#B5FCC6"
      />
    </svg>
  );
}
